/**
 * Progress bar component for running scans
 */

import { Progress } from '@/components/ui/progress'
import type { DiscoveryScan } from '@/types/discovery'

interface ScanProgressProps {
  readonly scan: DiscoveryScan
}

export function ScanProgress({ scan }: ScanProgressProps) {
  if (scan.status !== 'RUNNING' && scan.status !== 'PENDING') {
    return null
  }

  const total = scan.columnsScanned
  const classified = scan.columnsClassified
  const percentage = total > 0 ? Math.round((classified / total) * 100) : 0

  return (
    <div className="flex items-center gap-2">
      <Progress value={percentage} className="h-2 flex-1" />
      <span className="text-xs text-muted-foreground tabular-nums">
        {percentage}%
      </span>
    </div>
  )
}
